import React from 'react';
import { Box, Typography } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { linkedFieldNotes } from '../utils/linkedFields';

const codeSx = {
  color: '#cbd5e1', fontSize: '0.74rem', fontFamily: 'monospace',
  wordBreak: 'break-all', overflowWrap: 'anywhere',
};
const lineSx = { color: '#94a3b8', fontSize: '0.74rem', mt: 0.5, lineHeight: 1.5 };

function FieldList({ label, fields }) {
  return (
    <Typography sx={lineSx}>
      {label}{' '}
      {fields.map((field, index) => (
        <React.Fragment key={field}>
          {index > 0 && ', '}
          <Typography component="code" sx={codeSx}>{field}</Typography>
        </React.Fragment>
      ))}
    </Typography>
  );
}

/**
 * DPS-4708: linked-field notes for the reviewer (a partner left unchanged or written in the same fix, the
 * gather.json note for imageUrl, the agent's suggested partner change). Renders nothing when there are none.
 */
export default function LinkedFieldNotes({ ctx }) {
  const notes = linkedFieldNotes(ctx);
  if (!notes) return null;

  return (
    <Box sx={{
      display: 'flex', alignItems: 'flex-start', gap: 1.5, mx: 3, mt: 1.5, px: 2, py: 1.25,
      background: 'rgba(245,158,11,0.06)', borderRadius: 1, border: '1px solid rgba(245,158,11,0.18)',
    }}>
      <LinkIcon sx={{ color: '#f59e0b', fontSize: 18, mt: 0.15, flexShrink: 0 }} />
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ color: '#f59e0b', fontSize: '0.82rem', fontWeight: 600 }}>
          Linked fields
        </Typography>
        {notes.notUpdated.length > 0 && <FieldList label="Not updated in this fix:" fields={notes.notUpdated} />}
        {notes.reviewNote && <Typography sx={lineSx}>{notes.reviewNote}</Typography>}
        {notes.updated && <FieldList label="Also updated in this fix:" fields={[notes.updated]} />}
        {notes.unverifiedNote && <Typography sx={lineSx}>{notes.unverifiedNote}</Typography>}
        {notes.gatherJsonNote && <Typography sx={lineSx}>{notes.gatherJsonNote}</Typography>}
        {notes.suggestedChange && (
          <Typography sx={lineSx}>
            {"Agent's suggested change: "}
            <Typography component="code" sx={codeSx}>{notes.suggestedChange}</Typography>
          </Typography>
        )}
      </Box>
    </Box>
  );
}
